import axios, { AxiosPromise } from 'axios';

import { VAULT_PRODUCT_ID } from '../../constants/vault';

import {
  IOrg,
  IUser,
  IUserOrg,
  IResponse,
} from './interfaces';
import { useSsoTokenForRequests } from '../../utils/sso';
import { Lazy } from '../../cdk/lazy';

const idmApi = new Lazy(() => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_IDM_API_URL,
  });

  useSsoTokenForRequests(instance);

  return instance;
});

export const getOrgs = (): AxiosPromise<IResponse<IOrg>> => idmApi.getInstance().get('/orgs');

export const getUsers = (): AxiosPromise<IResponse<IUser>> => idmApi.getInstance().get('/users');

export const getUsersByOrg = (orgId: number): AxiosPromise<IResponse<IUser>> => idmApi.getInstance().get(`/orgs/${orgId}/users`);

export const getUserOrgs = (userId: number): AxiosPromise<IResponse<IUserOrg>> => idmApi.getInstance().get(`/users/${userId}/user-orgs`);

export const getVaultOrgs = (): AxiosPromise<IResponse<IOrg>> => idmApi.getInstance().get(`/products/${VAULT_PRODUCT_ID}/orgs`);

export const getProductsByOrgId = (orgId: number): AxiosPromise<IResponse<IOrg>> => idmApi.getInstance().get(`/orgs/${orgId}/products`);
